export default __webpack_public_path__ + "static/media/logowhite.37f63179.svg";